import { useContext } from 'react';
import { AuthenticationContext } from './authentication-context';

export function useAuthentication() {
    const context = useContext(AuthenticationContext);
    if (null === context) {
        throw new Error('useAuthentication() must be used inside a <AuthenticationProvider>');
    }
    return context;
}
